import React from 'react';
import { FlameIcon, DropletIcon, SproutIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 relative bg-brand-dark overflow-hidden" data-id="element-149">
      {/* Background overlay simulation */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.1)_0%,rgba(10,10,10,1)_70%)]" data-id="element-150"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <span className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-153">
            El Descubrimiento
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-154">
            El Protocolo de Bio-Activación Folicular Termo-Génica™
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto font-light" data-id="element-155">
            No es "otro champú". Es una intervención biológica directa.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-156">
          <div data-id="element-157">
            <img src="https://i.postimg.cc/fLgBFb0S/portada-libro-para-pagina.webp" alt="Protocolo Maestro" className="rounded-lg shadow-2xl border border-white/10 opacity-80 mix-blend-luminosity hover:mix-blend-normal transition duration-500" data-id="element-158" />
          </div>

          <div data-id="element-159">
            <p className="text-gray-400 mb-6 font-light leading-relaxed" data-id="element-160">
              Las clínicas capilares detestan este compuesto porque no se puede
              patentar. El jengibre puro, extraído bajo nuestro método
              específico, contiene{' '}
              <strong className="text-white" data-id="element-161">Gingerol Activo</strong>.
            </p>
            <p className="text-gray-400 mb-6 font-light leading-relaxed" data-id="element-162">
              A través de la{' '}
              <span className="text-brand-gold font-semibold" data-id="element-163">
                Bio-Activación Folicular Termo-Génica™
              </span>
              , generamos una vasodilatación localizada. Un calor profundo que
              derrite los tapones de sebo y DHT (la hormona que asfixia tu
              cabello), abriendo el canal de alimentación de la raíz.
            </p>

            <ul className="space-y-4 text-gray-300" data-id="element-164">
              <li className="flex items-start" data-id="element-165">
                <FlameIcon className="w-4 h-4 text-brand-gold mt-1 mr-4 flex-shrink-0" data-id="element-166" />
                <span data-id="element-167">
                  Detiene la micro-inflamación del cuero cabelludo en 48 horas.
                </span>
              </li>
              <li className="flex items-start" data-id="element-168">
                <DropletIcon className="w-4 h-4 text-brand-gold mt-1 mr-4 flex-shrink-0" data-id="element-169" />
                <span data-id="element-170">
                  Irriga sangre rica en nutrientes directamente a la papila
                  dérmica.
                </span>
              </li>
              <li className="flex items-start" data-id="element-171">
                <SproutIcon className="w-4 h-4 text-brand-gold mt-1 mr-4 flex-shrink-0" data-id="element-172" />
                <span data-id="element-173">
                  Fuerza a los folículos inactivos a entrar nuevamente en fase
                  anágena (crecimiento).
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}